import styled from "styled-components";

export const Container = styled.div`
  a {
    cursor: pointer;
  }
`;

export const DatePickerContainer = styled.div`
  fieldset {
    border-bottom: none;
  }

  .react-datepicker-popper {
      width: max-content !important;    
  }
    
  .react-datepicker__input-container {
    input {
        width: 360px;
    }
  }

  .react-datepicker__month-container ~.react-datepicker__month-container .react-datepicker__day-names {
    margin-top: 21px !important;
  }
`;
